<template>
  <el-dialog
    title="对话"
    :visible="true"
    :before-close="closeForm"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="20%"
  >
    <el-form
      :model="refundFrom"
      :rules="rules"
      ref="refundFrom"
      label-width="50"
      class="demo-refundFrom"
    >
      <div
        v-for="item in chatList"
        :key="item.id"
        :class="item.username === '管理员' ? 'box1' : 'box2'"
      >
        <div class="time">{{ item.createtime }}</div>
        {{ item.content }}
      </div>

      <el-form-item label="输入对话" prop="remark">
        <el-input
          v-model.trim="refundFrom.content"
          :rows="3"
          maxlength="200"
          show-word-limit
          type="textarea"
        ></el-input>
      </el-form-item>
      <div class="align-center">
        <el-button type="primary" @click="submitForm()">确定</el-button>
        <el-button @click="closeForm()">取消</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  props: ["refund"],
  data() {
    return {
      refundFrom: {
        refundid: this.refund ? this.refund.id : "",
        orderid: this.refund ? this.refund.orderid : "",
        content: ""
      },
      chatList: [],
      rules: {}
    };
  },

  created() {
    // console.log("created");
  },

  mounted() {
    console.log("mounted");
    this.queryChatlog();
    this.setChatlogRead();
  },
  methods: {
    queryChatlog() {
      let requestModel = {
        refundid: this.refundFrom.refundid
      };
      this.$axios(this.$urlMapping["查询退款对话"], {
        data: requestModel
        // eslint-disable-next-line no-unused-vars
      }).then(result => {
        this.chatList = result;
        console.log(result);
      });
    },

    setChatlogRead() {
      let requestModel = {
        id: this.refundFrom.refundid
      };
      this.$axios(this.$urlMapping["退款对话设置已读"], {
        data: requestModel
      }).then(result => {
        console.log(result);
      });
    },

    submitForm() {
      if (!this.refundFrom.content) {
        this.$notify.error({
          title: "消息",
          message: "请输入对话内容"
        });
        return;
      }

      this.$axios(this.$urlMapping["保存退款对话"], {
        data: {
          orderid: this.refundFrom.orderid,
          refundid: this.refundFrom.refundid,
          content: this.refundFrom.content
        }
        // eslint-disable-next-line no-unused-vars
      }).then(result => {
        console.log(result);
        this.refundFrom.content = "";
        this.queryChatlog();
      });
    },
    closeForm() {
      this.$emit("closeForm");
    }
  }
};
</script>

<style lang="less" scoped>
.time {
  line-height: 0.5;
  padding: 10px 6px;
  font-size: 10px;
}

.box1 {
  margin-top: 5px;
  line-height: 1.2;
  padding: 10px 6px;
  font-size: 120%;

  background-color: #c8daee;
  border: 1px solid #414df1;
  border-bottom: 3px solid #414df1;

  /*  我们用 border-radius 给边框加“圆角” */
}
.box2 {
  margin-top: 5px;
  line-height: 1.2;
  padding: 10px 6px;
  background-color: #e7ffe7;
  border: 1px solid #4caf50;
  border-bottom: 3px solid #4caf50;
  font-size: 120%;
}
</style>
